module.exports = __webpack_public_path__ + "h5/img/xijiao.8fe1f5c2.png";